import { mergeTemplate } from './base-template';

export const architekturTemplate = mergeTemplate({
  name: 'Architektur & Planung',
  icon: '🏗️',
  settings: {
    primaryColor: '#1c1917',
    accentColor: '#a3a3a3',
    fontStack: 'instrument',
    stylePreset: 'editorial',
    designDensity: 'airy',
    pageAngebot: {
      heroTitle: 'Leistungen & Honorare',
      heroSubtitle: 'Architektur von der Idee bis zur Realisierung',
      packages: [
        { name: 'Beratung & Vorentwurf', price: "ab CHF 2'500", description: 'Machbarkeit, erste Entwürfe, Kostenschätzung', features: 'Bestandsaufnahme, Machbarkeitsstudie, Vorentwurf, Kostenschätzung', highlighted: false },
        { name: 'Entwurf & Planung', price: 'nach SIA 102', description: 'Vom Vorprojekt bis zur Baubewilligung', features: 'Vorprojekt, Bauprojekt, Baubewilligung, Ausschreibung, Kostenvoranschlag', highlighted: true },
        { name: 'Bauleitung', price: 'nach SIA 102', description: 'Qualitätssicherung auf der Baustelle', features: 'Bauaufsicht, Terminplanung, Kostenkontrolle, Abnahme, Dokumentation', highlighted: false },
      ],
      ctaTitle: 'Bauen beginnt mit einer Idee',
      ctaText: 'Erzählen Sie uns von Ihrem Projekt — wir zeigen Ihnen die Möglichkeiten.',
      ctaButtonText: 'Erstberatung anfragen',
    },
    pageMethoden: {
      heroTitle: 'Unser Planungsprozess',
      heroSubtitle: 'Strukturiert, kreativ, SIA-konform',
      introText: 'Architektur ist ein Prozess. Wir begleiten Sie von der ersten Skizze bis zur Schlüsselübergabe — mit Klarheit und Leidenschaft.',
      steps: [
        { title: 'Programm & Analyse', description: 'Bedürfnisermittlung, Standortanalyse, baurechtliche Abklärungen' },
        { title: 'Entwurf', description: 'Kreative Lösungen, die Funktion, Ästhetik und Budget vereinen' },
        { title: 'Planung & Bewilligung', description: 'Detailplanung, Werkpläne, Ausschreibung, Baubewilligung' },
        { title: 'Realisierung', description: 'Bauleitung, Qualitätskontrolle, Abnahme und Übergabe' },
      ],
      tools: [
        { name: 'BIM / ArchiCAD', description: 'Digitale 3D-Planung und Koordination' },
        { name: 'SIA-Normen', description: 'Schweizer Standards für Qualität und Honorarordnung' },
        { name: 'Nachhaltigkeit', description: 'Minergie, SNBS und ökologische Materialwahl' },
      ],
      philosophyTitle: 'Architektur-Philosophie',
      philosophyText: 'Gute Architektur entsteht im Dialog — zwischen Mensch, Raum und Kontext. Wir entwerfen Orte, die Geschichten erzählen.',
    },
    pageUeberMich: {
      heroTitle: 'Unser Atelier',
      heroSubtitle: 'Architektur mit Haltung',
      introText: 'Wir sind ein interdisziplinäres Architekturbüro mit Erfahrung in Wohnbau, Gewerbe und öffentlichen Bauten.',
      timeline: [
        { year: '2008', text: 'Gründung des Ateliers' },
        { year: '2014', text: 'Erster öffentlicher Wettbewerbsgewinn' },
        { year: '2022', text: 'BSA-Aufnahme und Lehrauftrag' },
      ],
      values: [
        { title: 'Kontextualität', description: 'Jeder Entwurf respektiert den Ort und seine Geschichte' },
        { title: 'Präzision', description: 'Vom grossen Massstab bis zum Detail — alles durchdacht' },
        { title: 'Nachhaltigkeit', description: 'Verantwortungsvoll bauen für kommende Generationen' },
      ],
      certifications: 'BSA, SIA, REG A, Minergie-Fachpartner',
    },
  },
  components: {
    header: {
      companyName: 'Architektur Muster',
      logoText: 'AM',
      navItems: ['Projekte', 'Konzept', 'Team', 'Kontakt'],
      ctaText: 'Beratung anfragen',
    },
    hero: {
      title: 'Raum. Form. Kontext.',
      subtitle:
        'Architektur und Planung – von der Idee bis zur Realisierung.',
      primaryBtn: 'Projekt besprechen',
      secondaryBtn: 'Portfolio',
    },
    trust: {
      items: [
        { value: 'SIA', label: 'Normen' },
        { value: 'BIM', label: 'Digital' },
        { value: 'Nachhaltig', label: 'Konzept' },
        { value: 'Regional', label: 'Verankerung' },
      ],
    },
    services: {
      title: 'Leistungen',
      subtitle: 'Von der Machbarkeit bis zur Bauabnahme.',
      items: [
        {
          icon: '📐',
          title: 'Entwurf & Planung',
          text: 'Vorprojekt, Bauprojekt, Bewilligung – strukturiert und terminsicher.',
        },
        {
          icon: '🏠',
          title: 'Umbau & Sanierung',
          text: 'Bestand verstehen, sinnvoll erneuern.',
        },
        {
          icon: '📋',
          title: 'Bauleitung',
          text: 'Koordination, Qualitätskontrolle, Kostenübersicht.',
        },
      ],
    },
    process: {
      title: 'Ablauf',
      subtitle: 'Klare Phasen, transparente Kommunikation.',
      steps: [
        {
          num: '1',
          title: 'Erstgespräch',
          text: 'Ziele, Budget, Rahmenbedingungen klären.',
        },
        {
          num: '2',
          title: 'Konzept',
          text: 'Varianten entwickeln, Machbarkeit prüfen.',
        },
        {
          num: '3',
          title: 'Projekt',
          text: 'Detaillierte Planung, Bewilligung, Ausschreibung.',
        },
        {
          num: '4',
          title: 'Realisierung',
          text: 'Bauleitung, Abnahme, Dokumentation.',
        },
      ],
    },
    team: {
      title: 'Unser Atelier',
      subtitle: 'Interdisziplinäres Team mit Leidenschaft für Architektur.',
      members: [
        {
          name: 'Stefan Berger',
          role: 'Inhaber & Architekt BSA/SIA',
          image: '',
          bio: 'Entwurf, Wettbewerbe, Projektleitung. Lehrauftrag an der ZHAW.',
        },
        {
          name: 'Miriam Sutter',
          role: 'Architektin & Bauleiterin',
          image: '',
          bio: 'Ausführungsplanung, Bauleitung, Sanierungsprojekte.',
        },
      ],
    },
    testimonials: {
      title: 'Bauherrenstimmen',
      items: [
        {
          quote:
            'Professionelle Begleitung vom ersten Strich bis zum Einzug.',
          author: 'Markus Widmer',
          role: 'Bauherr, Einfamilienhaus Winterthur',
        },
        {
          quote: 'Unser Umbau wurde ein voller Erfolg — termingerecht, im Budget und wunderschön.',
          author: 'Claudia & Peter Huber',
          role: 'Gesamtsanierung Altbau, Bern',
        },
        {
          quote: 'Die kreative Lösung für unser schwieriges Grundstück hat uns überzeugt.',
          author: 'Familie Rüegg',
          role: 'Neubau, Zürcher Oberland',
        },
        {
          quote: 'Sehr strukturierter Ablauf und stets transparente Kommunikation. Klare Empfehlung.',
          author: 'Thomas Baumann',
          role: 'Geschäftsführer, Gewerbebau Aargau',
        },
      ],
    },
    faq: {
      title: 'FAQ',
      subtitle: '',
      items: [
        {
          question: 'Wie läuft ein Erstgespräch ab?',
          answer:
            'Wir besprechen Ihre Wünsche, das Budget und die Rahmenbedingungen — unverbindlich und kostenlos. Danach erhalten Sie eine erste Einschätzung zur Machbarkeit.',
        },
        {
          question: 'Was kostet ein Architekturprojekt?',
          answer:
            'Das Honorar richtet sich nach der SIA 102 Ordnung und hängt von Projektumfang und -komplexität ab. Eine erste Kostenschätzung erhalten Sie nach dem Vorentwurf.',
        },
        {
          question: 'Begleiten Sie auch Umbauten und Sanierungen?',
          answer:
            'Ja, Umbauten und Sanierungen sind ein Schwerpunkt unseres Ateliers. Wir bringen Erfahrung im Umgang mit Bestandsbauten und Denkmalschutz mit.',
        },
      ],
    },
    cta: {
      title: 'Projekt besprechen',
      subtitle:
        'Schildern Sie Ihr Vorhaben – wir skizzieren die nächsten Schritte.',
      phone: '+41 00 000 00 00',
      email: 'info@example.ch',
    },
    footer: {
      companyName: 'Architektur Muster',
      tagline: 'Architektur in Ihrer Region.',
      address: 'Musterstrasse 1, 8000 Zürich',
      phone: '+41 00 000 00 00',
      email: 'info@example.ch',
    },
  },
});
